import { inject, Injectable } from '@angular/core';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { ApiProviderService } from './api-provider.service';
import { Observable } from 'rxjs';
import { mapAsBody } from '../app/shared/util/request-util';
import { ICookieConsent } from '../models/cookie-consent.model';

@Injectable({ providedIn: 'root' })
export class CookieConsentService {
  readonly #apiProvider = inject(ApiProviderService);

  protected resourceUrl = API_ENDPOINTS.COOKIE_CONSENT;

  create(entity: ICookieConsent): Observable<ICookieConsent> {
    return this.#apiProvider.publicPost<ICookieConsent>(this.resourceUrl, entity).pipe(mapAsBody);
  }
}
